export function createMarkup(text) {
  return {
    __html: text
  };
}
